import { useCallback, useContext } from 'react'
import * as authService from '@/services/firebase/auth'
import { AuthContext } from './AuthContext'
import { AuthActionTypes } from './types'

export function useAuth() {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }

  const { state, dispatch } = context

  const reloadUser = useCallback(async () => {
    const freshUser = await authService.reloadCurrentUser()
    if (freshUser) {
      dispatch({ type: AuthActionTypes.AUTH_SUCCESS, payload: freshUser })
    }
  }, [dispatch])

  return {
    user: state.user,
    isAuthenticated: state.isAuthenticated,
    loading: state.loading,
    initialized: state.initialized,
    error: state.error,
    signInWithGoogle: authService.signInWithGoogle,
    signInWithApple: authService.signInWithApple,
    signInWithEmail: authService.signInWithEmail,
    signUpWithEmail: authService.signUpWithEmail,
    signOut: authService.signOut,
    resetPassword: authService.resetPassword,
    reloadUser
  }
}
